import {
  VERIFY_QR_UNIQUEID_NUMBERNOTREGISTERED,
  VERIFY_QR_UNIQUEID_INVALID_REQUEST,
  VERIFY_QR_UNIQUEID_SUCCESS,
  RESET_VERIFY_QR_UNIQUEID,
  LOADING_VERIFY_QR_UNIQUEID,
} from "../types";

const initialState = {
  isLoading: false,
  numberNotRegistered: false,
  success: false,
  invaliReq: false,
  status: "",
  networkError: "",
  data: {},
};

export default (state = initialState, action) => {
  switch (action.type) {
    case LOADING_VERIFY_QR_UNIQUEID:
      return {
        ...state,
        isLoading: true,
        numberNotRegistered: false,
        success: false,
        invalidReq: false,
        status: "",
        networkError: "",
        data: {},
      };

    case VERIFY_QR_UNIQUEID_INVALID_REQUEST:
      return {
        ...state,
        isLoading: false,
        numberNotRegistered: false,
        success: false,
        invalidReq: true,
        status: "Something went wrong",
        networkError: "",
        data: action.payload,
      };

    case VERIFY_QR_UNIQUEID_NUMBERNOTREGISTERED:
      return {
        ...state,
        isLoading: false,
        numberNotRegistered: true,
        success: false,
        invalidReq: false,
        status: "Number Not Registered",
        networkError: "",
        data: action.payload,
      };
    case VERIFY_QR_UNIQUEID_SUCCESS:
      return {
        ...state,
        isLoading: false,
        numberNotRegistered: false,
        success: true,
        invalidReq: false,
        status: "",
        networkError: "",
        data: action.payload,
      };

    case RESET_VERIFY_QR_UNIQUEID:
      return (state = initialState);

    default:
      return state;
  }
};
